import React from 'react'

import useRouter from '../../../../hooks/useRouter'
import useTranslations from '../../../../hooks/useTranslations'
import { ANGANWADI_CENTER } from '../../../../routing/pathName.constant'
import ANTDModal from '../../../../shared/antd/ANTDModal'
import PopUpConfirm from '../../../../shared/PopUpConfirm'
import { userWiseRole } from '../../../../utils/constant'
import { include, isEqual, notEqual } from '../../../../utils/javascript'
import UserTable from '../../../userManagement/presentation/UserTable'
import { userRelationKey } from '../../../userManagement/user.description'
import unassignedAnganwadi from '../../container/unassignedAnganwadi.container'

const UnassignedAnganwadiCenters = () => {
  const { t } = useTranslations()
  const { inspectionOfficer, anganwadiCenter } = userWiseRole
  const { location } = useRouter()

  const {
    hostelData,
    inspectionOfficerModal,
    handleViewClick = () => {},
    handleTableChange,
    handleAssignInspectionOfficer,
    handleAssignInspectionOfficerRandomly,
    handleCloseInspectionOfficerModal,
    inspectionOfficerData,
    handleInspectionOfficerTableChange,
    onAssignInspectionOfficer,
    confirmAssignInspectionRandomModal,
    confirmAssignInspectionOfficer,
  } = unassignedAnganwadi()
  return (
    <>
      {include(location.pathname, ANGANWADI_CENTER) ? (
        <h2 className="page-title">{t('job_UnassignedAnganwadiCenters')}</h2>
      ) : null}
      <UserTable
        userData={hostelData}
        handleTableChange={handleTableChange}
        handleView={handleViewClick}
        payload={{ roleId: anganwadiCenter }}
        removeEditBtn={notEqual(location.pathname, `/${ANGANWADI_CENTER}`)}
        isCardView={false}
        pagination={true}
        handleAssignInspectionOfficer={handleAssignInspectionOfficer}
        handleAssignInspectionOfficerRandomly={
          handleAssignInspectionOfficerRandomly
        }
        showAssignInspectionOfficer={true}
        columnFilter={[
          'user_Image',
          'user_Name',
          'user_AWCRegNo',
          'user_Project',
          'user_Address',
          'user_Contact',
          'user_LastInspectionDate',
          'txt_Action',
        ]}
        permission={isEqual(location.pathname, `/${ANGANWADI_CENTER}`)}
      />
      {inspectionOfficerModal?.open && (
        <ANTDModal
          title={t('user_InspectionOfficer')}
          centered
          open={inspectionOfficerModal?.open}
          onCancel={handleCloseInspectionOfficerModal}
          footer={false}
          width={1000}
        >
          <UserTable
            className="mb-15"
            userData={inspectionOfficerData}
            payload={{
              roleId: inspectionOfficer,
              relationType: userRelationKey.nonAssociate,
            }}
            searchPayload={{
              roleId: inspectionOfficer,
              relationType: userRelationKey.associate,
            }}
            isSearch
            handleTableChange={handleInspectionOfficerTableChange}
            handleSelect={onAssignInspectionOfficer}
            // multiSelect
          />
        </ANTDModal>
      )}
      {confirmAssignInspectionRandomModal?.open && (
        <PopUpConfirm
          isOpen={confirmAssignInspectionRandomModal?.open}
          onCancelModel={handleAssignInspectionOfficerRandomly}
          onAccept={confirmAssignInspectionOfficer}
          onReject={handleAssignInspectionOfficerRandomly}
          description={t('msg_AreYouSureWantToAssign')}
        />
      )}
    </>
  )
}

export default UnassignedAnganwadiCenters
